import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import * as moment from "moment";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { Branch } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { form_control } from "projects/sepidz-web-framework/src/lib/models/form-control.model";
import { take, takeUntil } from "rxjs/operators";
import { InvDailyDetail, InvDailyHeader } from "../../model/inv-daily-header.model";
import { InvDailyKindEnum } from "../inv-daily-kind.enum";
import { InvDailyListDialogComponent } from "../inv-daily-listdialog/inv-daily-listdialog.component";
import { PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";

@Component({
  selector: "ngx-inv-daily-voucher-form",
  templateUrl: "./inv-daily-form.component.html",
  styleUrls: ["./inv-daily-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvDailyFormComponent extends BaseFormComponent<InvDailyHeader> {
  itemColumns: form_control[];
  DateNow: string;
  BranchLookUp: Branch[] = [];
  goodsList: any[];
  invDailyKindEnum = InvDailyKindEnum;
  constructor(
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    __id: FormContainerModel,
    private _tabsservice: TabularService,
    private datatransfer: Datatransfer
  ) {
    super(selectorService, cd);
    this._id = __id;
    this.currentrow = this.datatransfer?.currentrow;
    this.tabsservice = _tabsservice;
  }

  async ngOnInit() {
    this.apiName = "InvDailyHeader";
    this.pathPreFix = "SALE";
    this.reportName = "InvDailyDetails";
    this.label = this.translate("ClientApp.Pages.PageMenu.InvDailyHeader");
    super.ngOnInit();
    const m = moment();
    this.DateNow = m.locale("fa").format("YYYY/MM/DD");
    await this.FillData();
  }

  async FillData() {
    const data = await (<Promise<Branch[]>>this.httpCommonService.getList("Branch").pipe(take(1)).toPromise());
    if (this.isMultiBranch) {
      this.BranchLookUp = data.filter((x) => !x.AccessToAllBranches && x.IsActive);
    } else this.BranchLookUp = data.filter((x) => x.Id == this.accountService.authService.currentBranch?.Id);

    if (this.isMultiBranch) {
      this.httpCommonService
        .get("Item/ReadInvDailyGoodsLookUpPaging")
        .pipe(take(1))
        .subscribe((res: PagingDataResult<any>) => {
          this.goodsList = res.Data;
          this.selectorService.setDataList("GoodsId", this.goodsList);
        });
    }
  }

  setdefault(): void {
    if (!this.model.InvDailyDetails) this.model.InvDailyDetails = [];
    if (!this.model.VoucherDate) this.model.VoucherDate = this.DateNow as any;
    if (!this.model.FiscalYearId) this.model.FiscalYearId = this.accountService.authService.currentFiscalYear?.Id;
    if (!this.isMultiBranch) this.model.BranchId = this.accountService.authService.currentBranch?.Id;
  }

  addControl(): void {
    this.setValue("VoucherDate", this.model.VoucherDate);
    this.setValue("InvVoucherHeaderId", this.model.InvVoucherHeaderId);
    this.setValue("Code", this.model.Code);
    this.setValue("BranchId", this.model.BranchId);
    this.setValue("Kind", this.model.Kind);
    this.setValue("WarehouseId", this.model.WarehouseId);
    this.setValue("FiscalYearId", this.model.FiscalYearId);
    this.setValue("Description", this.model.Description);
    if (!this.isMultiBranch || (this.isMultiBranch && this.currentrow)) this.formGroup.controls["BranchId"].disable();
    if (this.currentrow && this.currentrow.InvVoucherHeaderId) {
      this.formGroup.controls["VoucherDate"].disable();
      this.formGroup.controls["Description"].disable();
    }
  }

  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.selectorService.setTakeValue("GoodsId", 1000);
    this.itemColumns = this.getDetailControlModels("InvDailyDetails");
    const goodsIdControl = this.itemColumns.find((x) => x.name === "GoodsId");
    const goodsTitleControl = this.itemColumns.find((x) => x.name === "GoodsTitle");
    if (goodsIdControl && !goodsIdControl["custom"]) {
      goodsIdControl.name = "GoodsTitle";
      goodsIdControl["custom"] = true;
    }
    if (goodsTitleControl && !goodsTitleControl["custom"]) {
      goodsTitleControl.name = "GoodsId";
      goodsTitleControl["custom"] = true;
    }
  }

  onLookupRowSelect(group: any) {
    console.log(group);
  }

  isValid() {
    if (!this.model.InvDailyDetails.filter((x) => x.State !== RowState.Detached && x.State !== RowState.Delete).length) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Inv.DailyHeader.EnterRequiredMinimizeItem"),
        this.translate("ClientApp.FrontOffice.Inv.DailyHeader.Attention")
      );
      return false;
    }
    if (this.model.InvDailyDetails.filter((x) => x.State !== RowState.Detached && x.State !== RowState.Delete).find((x) => x.Amount <= 0)) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Inv.DailyHeader.InSomeRowsValueZeroOrNegative"),
        this.translate("ClientApp.FrontOffice.Inv.DailyHeader.Attention")
      );
      return false;
    }
    return super.isValid();
  }

  beforupdate() {
    if (this.model.InvDailyDetails && this.model.InvDailyDetails?.length > 0) {
      this.model.InvDailyDetails = this.model.InvDailyDetails?.filter((x) => x.State !== RowState.Detached);
      if (!this.formGroup.controls["InvDailyDetails"])
        this.formGroup.addControl("InvDailyDetails", new UntypedFormControl(this.model?.InvDailyDetails));
      else this.formGroup.controls["InvDailyDetails"].setValue(this.model?.InvDailyDetails);
      this.formGroup.updateValueAndValidity();
    }
    this.model.InvDailyDetails.forEach((x) => {
      if (!x.InvDailyHeaderId) x.InvDailyHeaderId = this.model.Id;
    });
  }

  protected isCloseable(): boolean {
    this.selectorService.submitted$.next(false);
    this.formGroup?.markAsUntouched();
    return true;
  }

  removeEmptyValues() {
    this.model.InvDailyDetails = this.model.InvDailyDetails.filter((x) => x.Amount !== 0);
    this.cd.markForCheck();
  }

  ShowList() {
    this.dialogService
      .open(InvDailyListDialogComponent as any, { closeOnClickOutside: true })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((details: InvDailyDetail[]) => {
        if (details?.length) {
          this.model.InvDailyDetails = details;
          this.cd.markForCheck();
        }
      });
  }

  reject() {
    this.model.Kind = InvDailyKindEnum.Reject;
    this.setValue("Kind", this.model.Kind);
    this.model.State = RowState.Modify;
    this.save().then();
  }

  confirm() {
    this.model.Kind = InvDailyKindEnum.Confirm;
    this.setValue("Kind", this.model.Kind);
    this.model.State = RowState.Modify;
    this.save().then();
  }

  onBranchChanges(branch: any) {
    if (this.isMultiBranch && branch) {
      const BranchId = branch.Id;
      const list = this.goodsList.filter((x) => x.BranchId == BranchId || !x.branchId);
      const goodsWithBranchZero = list.filter((g) => g.BranchId === 0);
      const goodsToRemove: any[] = [];

      goodsWithBranchZero.forEach((good) => {
        const equivalentGood = list.find((g) => g.Id === good.Id && g.BranchId !== 0);
        if (equivalentGood) goodsToRemove.push(good);
      });

      goodsToRemove.forEach((goodToRemove) => {
        const index = list.findIndex((g) => g.Id === goodToRemove.Id);
        if (index !== -1) {
          goodsToRemove.splice(index, 1);
        }
      });
      this.selectorService.setDataList("GoodsId", list);
    }
  }

  onRowSelected() {
    if (this.isMultiBranch) {
      if (!this.formGroup.controls["BranchId"].value) {
        this.sts.showDialog(this.translate("ClientApp.FrontOffice.Inv.DailyHeader.SelectDesiredBranchFirst"), "");
      } else this.formGroup.controls["BranchId"].disable();
    }
  }
  afterDeleted() {
    if (!this.isMultiBranch && !this.model.InvDailyDetails.filter((x) => x.State !== RowState.Detached && x.State !== RowState.Delete).length) {
      this.formGroup.controls["BranchId"].enable();
    }
  }

  ngOnDestroy(): void {
    this.selectorService.dataList["GoodsId"] = null;
    delete this.selectorService.dataList["GoodsId"];
    super.ngOnDestroy();
  }
}
